/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Signup_FailedInputs */

const en_auth_error_signup_failed = /** @type {(inputs: Auth_Error_Signup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signup failed`)
};

const de_auth_error_signup_failed = /** @type {(inputs: Auth_Error_Signup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung fehlgeschlagen`)
};

const fr_auth_error_signup_failed = /** @type {(inputs: Auth_Error_Signup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscription échouée`)
};

const es_auth_error_signup_failed = /** @type {(inputs: Auth_Error_Signup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de registro`)
};

const it_auth_error_signup_failed = /** @type {(inputs: Auth_Error_Signup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione non riuscita`)
};

const nl_auth_error_signup_failed = /** @type {(inputs: Auth_Error_Signup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registratie mislukt`)
};

const pl_auth_error_signup_failed = /** @type {(inputs: Auth_Error_Signup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejestracja nie powiodła się`)
};

const fi_auth_error_signup_failed = /** @type {(inputs: Auth_Error_Signup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekisteröityminen epäonnistui`)
};

const da_auth_error_signup_failed = /** @type {(inputs: Auth_Error_Signup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettelse mislykkedes`)
};

const sv_auth_error_signup_failed = /** @type {(inputs: Auth_Error_Signup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrering misslyckades`)
};

/**
* | output |
* | --- |
* | "Signup failed" |
*
* @param {Auth_Error_Signup_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_error_signup_failed = /** @type {((inputs?: Auth_Error_Signup_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Signup_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_error_signup_failed(inputs)
	if (locale === "fr") return fr_auth_error_signup_failed(inputs)
	if (locale === "es") return es_auth_error_signup_failed(inputs)
	if (locale === "it") return it_auth_error_signup_failed(inputs)
	if (locale === "nl") return nl_auth_error_signup_failed(inputs)
	if (locale === "pl") return pl_auth_error_signup_failed(inputs)
	if (locale === "fi") return fi_auth_error_signup_failed(inputs)
	if (locale === "da") return da_auth_error_signup_failed(inputs)
	if (locale === "sv") return sv_auth_error_signup_failed(inputs)
	return en_auth_error_signup_failed(inputs)
});